import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-layer-config-collapsible-category',
  templateUrl: './layer-config-collapsible-category.component.html',
  standalone: false,
})
export class LayerCollapsibleCategoryComponent {
  @Input() description: string = ''
  @Input() isVisible: boolean | undefined = true
  @Input({ required: true }) storageKey!: string
  @Input() collapsedDefault: boolean = true

  public isCollapsed = this.collapsedDefault

  ngOnInit(): void {
    this.isCollapsed = this.getStoredCollapsedState()
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed
    this.storeCollapsedState()
  }

  private get fullStorageKey(): string {
    return `obstacle-layer-group-${this.storageKey}-collapsed`
  }

  private getStoredCollapsedState(): boolean {
    const storedState = localStorage.getItem(this.fullStorageKey)

    if (storedState === null) {
      return this.collapsedDefault
    }

    return storedState === 'true'
  }

  private storeCollapsedState(): void {
    localStorage.setItem(this.fullStorageKey, String(this.isCollapsed))
  }
}
